export const resultForm = {
  노출및판매기간설정: {
    상품노출기한설정: "",
    상품판매기한설정: "",
  },
  상품기본정보: {
    카테고리: [],
    필터태그: [],
    상품명: "",
    상품코드: "",
    상품구성소개정보: "",
    상품썸네일: "",
    상품대표이미지: [],
    상품총재고: 0,
  },
  상품옵션: [
    {
      옵션이미지: "",
      옵션컨텐츠: [
        {
          옵션명: "",
          상품정상가: 0,
          상품판매가: 0,
          상품재고: 0,
          과세여부: "",
          추가옵션: [],
        },
      ],
    },
  ],
  상품소개이미지: [],
  구매자추천이미지: [],
  상품정보고시: [
    {
      제품명_중량: "",
      원산지_원재료함량: "",
      등급: "",
      보관: "",
      식품유형: "",
      추가항목: [],
    },
  ],
  상품배송설정: {
    사용자배송일지정: false,
    방문수령: false,
    선주문예약배송: true,
    선주문예약배송시간: { 주문시간: "", 새벽배송: "", 일반배송: "" },
  },
  상품혜택허용설정: {
    마일리지적립: true,
  },
  기타설정: {
    감사카드설정: false,
  },
};
